import { createRoute, Outlet } from '@tanstack/react-router';
import { layoutRoute } from '@app/router/layout';
import { ProposalCreationClientAndMortgage } from '@modules/proposals/presentation/v2/pages/ProposalCreation/views/ClientAndMortgage';
import { SortOrder } from '@components/Table';
import { ProposalPreviewPage } from '@modules/proposals/presentation/v2/pages/Preview';
import { ProposalsList } from '@modules/proposals/presentation/v2/pages/List';
import { ProposalConfiguratorPage } from '@modules/proposals/presentation/v2/pages/ProposalCreation/views/Configurator';
import { ProposalBankProducts } from '@modules/proposals/presentation/v2/pages/ProposalCreation/views/BankProducts';
import { rootRoute } from '@app/router/root';
import { EditableTemplate } from '@modules/proposals/presentation/v2/pages/ProposalCreation/es/views/EditableTemplate';
import ProposalCreationLayout from '@modules/proposals/presentation/v2/pages/ProposalCreation';

export const ProposalsLayoutRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/proposals',
  beforeLoad: () => ({ featureName: 'proposals.module' }),
  component: () => <Outlet />,
});

export const ProposalPreviewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/proposals/$proposalId/preview',
  component: () => (
    <ProposalPreviewPage />
  ),
});

export type ProposalsRouteSearchQuery = {
  q?: string;
  page?: number;
  sort?: string;
  order?: SortOrder;
  proposal_id?: string;
};

export const ProposalsListRoute = createRoute({
  getParentRoute: () => ProposalsLayoutRoute,
  path: '/',
  beforeLoad: () => ({ breadcrumb: { key: 'proposalListing' } }),
  component: () => (
    <ProposalsList />
  ),
  validateSearch: ({
    q, page, sort, order, proposal_id,
  }: ProposalsRouteSearchQuery): ProposalsRouteSearchQuery => ({
    q, page: page ?? 1, sort, order, proposal_id,
  }),
});

export const ProposalCreationRoute = createRoute({
  getParentRoute: () => ProposalsLayoutRoute,
  path: '/$id',
  beforeLoad: () => ({ breadcrumb: { key: 'proposalListing.create' } }),
  component: () => (
    <ProposalCreationLayout>
      <Outlet />
    </ProposalCreationLayout>
  ),
});

export const ProposalEditableTemplateRoute = createRoute({
  getParentRoute: () => ProposalCreationRoute,
  path: '/template',
  beforeLoad: () => ({ featureName: 'proposals.baytecaMVP' }),
  component: () => (
    <EditableTemplate />
  ),
});

export const ProposalCreationClientAndMortgageRoute = createRoute({
  getParentRoute: () => ProposalCreationRoute,
  path: '/client-and-mortgage',
  component: () => (
    <ProposalCreationClientAndMortgage />
  ),
});

export const ProposalCreationBankProductsRoute = createRoute({
  getParentRoute: () => ProposalCreationRoute,
  path: '/bank-products',
  component: () => (
    <ProposalBankProducts />
  ),
});

export const ProposalCreationConfiguratorRoute = createRoute({
  getParentRoute: () => ProposalCreationRoute,
  path: '/config',
  component: () => (
    <ProposalConfiguratorPage />
  ),
});
